export const appBrokerResources = {
  SUBSCRIPTION_PAGE: `Page de souscription d'une agence`,
};
